import { action } from "satcheljs";

/**
 * Refreshes the inbox rules store each time a new folder is added.
 */
export interface ON_FOLDER_CREATEDActionMessage {
    folderId: string;
}
const defaultExport: (folderId: string) => ON_FOLDER_CREATEDActionMessage = action("ON_FOLDER_CREATED", (folderId: string): ON_FOLDER_CREATEDActionMessage => ({
    folderId,
}));

export default defaultExport;
